import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "little-mountain",
  name: "Little Mountain",
  title: "Little Mountain conveyancing and wills lawyers",
  metaTitle: `Little Mountain Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Little Mountain conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, EPOAs and estate advice from a local Caloundra-area firm. Call ${FIRM.phone}.`,
  lead: "Little Mountain is largely established family housing with pockets of newer estate and over-50s development. Most contracts are straightforward — until an easement, a covenant or an unapproved shed turns up.",
  paragraphs: [
    "We act for Little Mountain buyers and sellers from Golden Beach, minutes away. Family homes here often come with a pool, a shed, solar or a granny flat added over the years, and each of those raises an approval or compliance question in the contract.",
    "Pool safety certificates are the most common one. A seller must either give a compliance certificate before settlement or a notice of no pool safety certificate before the contract is signed — and the buyer then has a limited window to comply.",
    "We also prepare wills, enduring powers of attorney and advance health directives for Little Mountain families and advise on granny flat arrangements for parents moving in with adult children.",
  ],
  localNotes: [
    {
      t: "Pool safety certificates",
      d: "Non-shared pools require a certificate at settlement or a pre-contract notice. If the notice route is used, the buyer must obtain compliance within 90 days at their own cost.",
    },
    {
      t: "Granny flats and secondary dwellings",
      d: "Check approvals and whether the dwelling can lawfully be rented separately. If a parent is contributing money, a written granny flat agreement protects everyone.",
    },
    {
      t: "Easements and covenants",
      d: "Drainage easements and estate covenants control where you can build, fence and landscape. The title search and community management statement tell the real story.",
    },
    {
      t: "Solar, batteries and leases",
      d: "Leased or financed solar systems do not always transfer cleanly. We confirm ownership and any PPSR registration before settlement.",
    },
  ],
  suburbs: ["Caloundra West", "Aroona", "Currimundi", "Meridan Plains", "Pelican Waters", "Golden Beach"],
  faqs: [
    {
      q: "Who pays for pool safety compliance in a Queensland sale?",
      a: "If the seller gives a compliance certificate, the cost is theirs. If they instead give a notice of no pool safety certificate before the contract is signed, the buyer must obtain compliance within 90 days of settlement and bears that cost — so it should be priced into your offer.",
    },
    {
      q: "Can I rent out a granny flat on my Little Mountain property?",
      a: "It depends on the approval for the secondary dwelling and the relevant planning scheme provisions. We check the approval history before you rely on rental income.",
    },
    {
      q: "Do you prepare granny flat agreements for family arrangements?",
      a: "Yes. Where a parent contributes to a build or a purchase, a written agreement setting out contributions, occupation rights and what happens if circumstances change avoids the most common family disputes — and has Centrelink implications worth advice.",
    },
  ],
};
